import { useRemoveClickedStyle } from "@hooks/useRemoveClickedStyle";
import { getDaysInMonth } from "@utils/dayUtill";
import type * as type from "@vTypes";
import { useMemo } from "react";
import WeeklyOffTdShiftCodeBtnView from "./WeeklyOffTdShiftCodeBtnView";

function ModalRowNurseRosterListView({
  nurse,
  shiftInfo,
  year,
  month,
  index
}: {
  nurse?: any;
  shiftInfo: {
    shift_id: string;
    name: string;
    color: string;
  }[];
  year?: number;
  month?: number;
  index?: number;
}) {
  const getDaysInMonthNum = useMemo(() => {
    if (!year || !month) return 0;
    return getDaysInMonth(year, month);
  }, [year, month]);

  // 외부 영역 클릭 시 선택 효과(.clicked)를 해제하는 로직
  useRemoveClickedStyle();

  return (
    <div className={`rt_tbody_tr`}>
      <div className="rt_nurseInfo_flexWrap">
        {/* NO */}
        <div className="rt_nurse_name flex !items-center justify-end w-[20px]">
          <div className="padding_hover_bg_vertical effect_hover_bg_vertical">
            <div className="padding_hover_bg_horizon effect_hover_bg_horizon place-content-center !pl-[20px]">
              <span className="text-[12px] text-[#666666] whitespace-nowrap mt-[2px]">{index}</span>
            </div>
          </div>
        </div>

        {/* 연결하기 위한 빈 공간 */}
        <div className="rt_whiteSpace !w-[12px]">
          <div className="padding_hover_bg_horizon effect_hover_bg_horizon ">
          </div>
        </div>
        {/* 직군*/}
        <div className="rt_nurse_name">
          <div className="padding_hover_bg_vertical effect_hover_bg_vertical">
            <div className="padding_hover_bg_horizon effect_hover_bg_horizon !pr-[5px] !w-[52px]">
              <div className="rt_nurse_name_block_name flex justify-center"><span>{nurse?.role}</span></div>
            </div>
          </div>
        </div>
        {/* 이름 */}
        <div className="rt_nurse_name">
          <div className="padding_hover_bg_vertical effect_hover_bg_vertical">
            <div className="padding_hover_bg_horizon effect_hover_bg_horizon ">
              <div className="rt_nurse_name_block_name flex justify-center !w-[55px] !min-w-[55px]">{nurse?.name}</div>
            </div>
          </div>
        </div>
      </div>

      {/* 근무코드 */}
      <div className="rt_date_flexWrap rt_date_flexWrap--view pl-0 translate-x-0.5">
        <div className="rt_whiteSpace" style={{ width: "3px" }}>
          <div
            className="effect_hover_bg_horizon"
            style={{ width: "100%", height: "100%" }}
          ></div>
        </div>

        {/* 월의 마지막 날짜만큼 반복 */}
        {year &&
          month &&
          Array.from({ length: getDaysInMonthNum }, (_, index) => {
            const day = index + 1;
            const date = new Date(year, month - 1, day);
            // getDay()는 일요일(0) ~ 토요일(6)을 반환. API는 월요일(0) ~ 일요일(6)이므로 변환.
            // (date.getDay() + 6) % 7 => 월(0), 화(1), ..., 일(6)
            const dayOfWeek = (date.getDay() + 6) % 7;

            // 간호사의 주휴 요일과 현재 날짜의 요일이 일치하는 경우에만 shift를 할당
            const shift =
              dayOfWeek === nurse?.weekly_off_weekday
                ? shiftInfo.find((item) => item.shift_id === "주")
                : undefined;

            return (
              <WeeklyOffTdShiftCodeBtnView
                key={index}
                day={index + 1}
                shift={shift}
                prefix="weeklyOff-"
              />
            );
          })}

        <div className="rt_whiteSpace" style={{ width: "10px" }}>
          <div
            className="effect_hover_bg_horizon"
            style={{ width: "100%", height: "100%" }}
          ></div>
        </div>
      </div>
    </div>
  );
}
export default ModalRowNurseRosterListView;
